import { AsyncPipe } from '@angular/common';
import { Component, InjectionToken, Input, OnDestroy, OnInit, inject } from '@angular/core';

import { CommonMessages } from '@frontend/vanilla/core';
import { Observable, delay } from 'rxjs';

import { CustomLoadingIndicatorExtendedService } from './custom-loading-indicator.service';

export const LOADING_INDICATOR = new InjectionToken<string>('ms-loading-indicator');

/**
 * Used to create loading indicators on custom place on the page.
 * Use it along with @see {@link CustomLoadingIndicatorService} use the same token as the one this component is registered
 */
@Component({
    selector: 'ms-loading-indicator',
    templateUrl: './loading-indicator.component.html',
    imports: [AsyncPipe],
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
    private commonMessages = inject(CommonMessages);
    private customLoadingIndicatorService = inject(CustomLoadingIndicatorExtendedService);
    private token = inject(LOADING_INDICATOR);

    isVisible$: Observable<boolean>;
    @Input() delay = 0;

    get fallbackMessage(): string {
        return this.commonMessages['PleaseWait'];
    }

    ngOnDestroy(): void {
        this.customLoadingIndicatorService.unregisterLoadingIndicator(this.token);
    }

    ngOnInit(): void {
        const visibilityService = this.customLoadingIndicatorService.registerLoadingIndicator(this.token);
        this.isVisible$ = visibilityService.visible.pipe(delay(this.delay));
    }
}
